export default (string = "") => {
  if (string === null) {
    return null;
  }
  if (string.substring(0, 2) === "R$") {
    return string.slice(2).replace(/\./g, "").replace(/,/g, ".");
  }
  return string.replace(/\./g, "").replace(/,/g, ".");
};
